// extracted by mini-css-extract-plugin
export default {"seriesLink":"Series__seriesLink--T4AJW"};